export function getQuickSortAnimation(array) {
  const animations = [];
  if (array.length <= 1) return array;
  QuickSort(array, 0, array.length, animations);
  return animations;
}

function QuickSort(array, startIdx, endIdx, animations) {
  if (startIdx < endIdx) {
    let pivot = Partition(array, startIdx, endIdx, animations);
    QuickSort(array, startIdx, pivot - 1, animations);
    QuickSort(array, pivot + 1, endIdx, animations);
  }
}

function Partition(array, startIdx, endIdx, animations) {
  let pivotIdx = endIdx;
  animations.push(["pivot", pivotIdx]); // pivot index into annimation array;
  let i = startIdx - 1;
  for (let j = startIdx; j < endIdx; j++) {
    if (array[j] <= array[pivotIdx]) {
      i++;

      let temp = array[j];
      array[j] = array[i];
      array[i] = temp;
      animations.push(["index", i, j, array[i], array[j]]); // comparrison and swap
    }
  }
  i++;

  let temp = array[pivotIdx];
  array[pivotIdx] = array[i];
  array[i] = temp;
  if (array[i] !== undefined) {
    animations.push(["pswapidx", i, pivotIdx, array[i], array[pivotIdx]]);
  }

  return i;
}
